<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" md="8">
        <b-card>
          <div slot="header">
            <i class="fa fa-money"></i> Tipo de Cambio
          </div> 
          <b-table
            hover
            striped
            small
            fixed
            show-empty
            empty-text="No hay registros para mostrar"
            responsive="sm"
            :items="items"
            :fields="fields"
            :per-page="perPage"
          >
            <template slot="top-row">
              <td :key="fecha" style="display: inline-flex">
                <datetime
                  v-model="fecha"
                  value-zone="America/Managua"
                  input-class="form-control"
                  @close="getTasas"
                  placeholder="Filtrar Fecha"
                >
                  <template slot="button-cancel">
                    <i class="fa fa-times" /> Cancelar
                  </template>
                  <template slot="button-confirm">
                    <i class="fa fa-check-circle" /> Confirmar
                  </template>
                </datetime>
                <a
                  class="btn btn-success"
                  style="color: white; font-size: normal"
                  @click="fecha = null; getTasas()"
                >
                  <i class="fa fa-times" />
                </a>
              </td>
              <td>
                <span>
                <input
                  type="text"
                  v-model="valor"
                  class="form-control"
                  v-on:keyup.enter="getTasas()"
                  style="display:inline; max-width: 45%"
                />
                 <a
                  class="btn btn-success"
                  style="color: white; font-size: normal"
                  @click="valor= null; getTasas()"
                >
                  <i class="fa fa-times" />
                </a></span>
              </td>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="mt-4"
            @input="getTasas"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script> 
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "TasaCambio",
  components: {
    Datetime
  },
  data: () => {
    return {
      items: [],
      fecha: null,
      valor: null,
      fields: [
        {
          key: "fecha",
          sortable: true,
          isRowHeader: true,
          formatter: "formatDate"
        },
        {
          key: "valor",
          sortable: true,
          formatter: "formatPrice"
        }
      ],
      perPage: 10,
      totalRows: 0,
      currentPage: 1
    };
  },
  created() {
    this.getTasas();
  },
  methods: { 
    async getTasas() {
      try {
        let response = await axios.post("/api/catalogos/tasa-cambio", {
          perPage: this.perPage,
          currentPage: this.currentPage,
          fecha: this.fecha,
          valor: this.valor
        });
        if(response.status == 200) {
          let {data, total} = response.data;
        this.items = data;
        this.totalRows = total;
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(4).replace(",", ".");
      return "C$ " + val.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ",");
    }
  }
};
</script> 